import { useEffect, useRef } from 'react';
import { Flex, Tabs } from 'antd';
import { AssetDetailHero } from './AssetDetailHero';
import type { AssetDetailPageViewProps } from './AssetDetailPage.types';
import { useAssetDetailTabItems } from './hooks/useAssetDetailTabItems';
import styles from './AssetDetailPageView.module.css';

export function AssetDetailPageView(props: AssetDetailPageViewProps) {
  const {
    summary,
    activeTab,
    hasChanges,
    isSaving,
    detailsReady,
    onBackAction,
    onActiveTabChangeAction,
    onResetAction,
    onSubmitAction,
    onDeleteAction,
    isDeleting = false,
    siteForMap,
    mapLatitude = null,
    mapLongitude = null,
    onHeaderMapClickAction,
  } = props;
  const tabItems = useAssetDetailTabItems(props);
  const tabsHostRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const host = tabsHostRef.current;
    if (!host || !activeTab) {
      return;
    }

    const activeNode = host.querySelector<HTMLElement>(
      `.ant-tabs-tab[data-node-key="${CSS.escape(activeTab)}"]`,
    );
    activeNode?.scrollIntoView({
      behavior: 'smooth',
      block: 'nearest',
      inline: 'nearest',
    });
  }, [activeTab]);

  return (
    <Flex vertical gap="large" className="app-detail-container">
      <AssetDetailHero
        assetName={summary.assetName}
        serialNumber={summary.serialNumber}
        assetTypeName={summary.assetType.name}
        assetModelName={summary.assetModel?.name}
        connectivityStatus={summary.connectivityStatus}
        lastSeenAt={summary.lastSeenAt}
        onBack={onBackAction}
        onDelete={
          onDeleteAction
            ? () =>
                onDeleteAction({
                  id: summary.id,
                  assetName: summary.assetName,
                  serialNumber: summary.serialNumber,
                })
            : undefined
        }
        isDeleting={isDeleting}
        onReset={detailsReady ? onResetAction : undefined}
        onSubmit={detailsReady ? onSubmitAction : undefined}
        hasChanges={detailsReady ? hasChanges : false}
        isSaving={isSaving}
        mapLatitude={mapLatitude}
        mapLongitude={mapLongitude}
        mapTitle={siteForMap?.name ?? summary.site.name ?? summary.assetName}
        onMapClick={onHeaderMapClickAction}
      />

      <section className={`evimo-list-panel ${styles.tabsPanel}`}>
        <div className={styles.tabsNav} ref={tabsHostRef}>
          <Tabs
            className={styles.tabs}
            activeKey={activeTab}
            onChange={onActiveTabChangeAction}
            destroyOnHidden
            items={tabItems}
          />
        </div>
      </section>
    </Flex>
  );
}
